// 项目通用
export const ZWSCommon = {
  // 主题色
  themeColor: '#8fc41e'
}
export const ZWSProject = {
  // 项目主题色
  projectThemeColor: ZWSCommon.themeColor,
  // 项目名
  projectName: '项目名称',
  // 项目logo
  projectLogo: require('@/assets/images/logo.png'),
  // 项目菜单栏
  projectMenu: [
    {
      icon: 'el-icon-s-order',
      title: '订单信息',
      index: '/Home/Order/OrderList'
    },
    {
      icon: 'el-icon-menu',
      title: '便签信息',
      index: '/Home/Label/LabelList'
    },
    {
      icon: 'el-icon-question',
      title: '测试',
      index: '/Home/Test/Test'
    }
  ],
  // 登录模块
  loginPropsList: {
    // 项目Logo
    projectLogo: require('@/assets/images/login/cloud_head_logo1.png'),
    // 项目名
    projectName: '致远标签打印系统',
    // 项目主题色
    projectThemeColor: ZWSCommon.themeColor,
    usernamePlaceholder: '请输入用户名',
    passwordPlaceholder: '至少8位字符',
    // // 用户输入框前缀图标
    // usernamePrefixIconSrc: require('@/assets/images/login_username_icon.png'),
    // // 密码输入框前缀图标
    // passwordPrefixIconSrc: require('@/assets/images/login_password_icon.png'),
    // // 密码输入框后缀图标之显示密码
    // passwordSuffixIconSrcVisible: require('@/assets/images/icon-visible.png'),
    // // 密码输入框后缀图标之隐藏密码
    // passwordSuffixIconSrcInVisible: require('@/assets/images/icon-invisible.png'),
    rememberPassword: '记住密码',
    forgetPassword: '忘记密码?',
    loginButtonText: '登录',
    experienceAccount: '体验账号',
    toRegister: '没有账号?马上注册',
    // 是否显示体验账号按钮
    showExperienceButton: false,
    // 登录背景 backgroundColor（背景颜色）/backgroundImage（背景图片） 二选一
    backgroundColor: '#0c192a',
    // backgroundImage: require('@/assets/images/login-bg.png'),
    // 登录区域宽度
    loginWidth: '522px',
    // 登录区域高度s
    loginHeight: '338px',
    // 登录区域背景颜色
    loginBackgroundColor: '#0c192a',
    // 登录区域文本颜色
    loginTextColor: '#ffffff'
  }

}



// WEBPACK FOOTER //
// ./src/native/ZWSProject.js